const testimonials = [
  {
    name: "David L.",
    location: "Suwanee, GA",
    rating: 5,
    text: "Family cruise to the Caribbean in two weeks and my passport was missing. Fast Passport Center walked us through the lost passport replacement, had us visit a local clerk in Lawrenceville, and got everything submitted the same day. We had new passports in hand before we flew out of Atlanta.",
    service: "Lost Passport Replacement",
  },
  {
    name: "Michelle R.",
    location: "Johns Creek, GA",
    rating: 5,
    text: "My daughter's study-abroad program in Spain required her passport within 10 days. We live in Johns Creek and work in Suwanee. The team made the whole child passport process feel manageable. Clear instructions, fast processing, and they answered every phone call.",
    service: "Child Passport",
  },
  {
    name: "James K.",
    location: "Duluth, GA",
    rating: 5,
    text: "Business trip to Singapore got moved up suddenly. I shipped my documents from a UPS store on Lawrenceville-Suwanee Road overnight. Fast Passport Center got my emergency passport processed in 5 days. Couldn't have done it without them.",
    service: "Emergency Passport",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function SuwaneeTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Gwinnett County Travelers Say About Our Expedited Passport Service
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from real travelers across Suwanee, Johns Creek, Duluth, and Gwinnett County who trusted Fast Passport Center with their emergency and expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col"
            >
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}